/* eslint-disable */
import React from "react";
import { FC } from "react";
import { useEffect } from "react";
import { isLocalEnvironment } from "../../services/environment";

const RaindropInputTextArea = ({
  value,
  onChange,
  label = "",
  example = "",
  isPopulatingExampleIfLocal = true,
  maxLength = 1000,
}) => {
  useEffect(() => {
    if (
      isPopulatingExampleIfLocal &&
      isLocalEnvironment() &&
      !value &&
      example
    ) {
      onChange({ target: { value: example } });
    }
  }, []);

  return (
    <div className="flex flex-col w-full gap-1">
      {label && (
        <div
          className={`text-sm text-left

          dark:text-color-dark-text-tertiary text-color-text-secondary
          `}
        >
          {label}
        </div>
      )}
      <textarea
        placeholder="Type here..."
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        className={`w-full  rounded-md p-2 focus:outline-none border 
          dark:border-color-dark-border-primary border-color-border-primary 
         bg-transparent
        placeholder-color-dark-text-secondary
        dark:text-color-dark-text-primary text-color-text-primary h-40
        `}
      />
    </div>
  );
};

export default RaindropInputTextArea;
